import type { ReactNode } from 'react';
import { useSession } from '@/session/useSession';
import { SessionGate } from './SessionGate';

/**
 * Route guard. Every authenticated view is wrapped in this: an active in-memory session renders the
 * children; ANY other state renders the gate — never a blank authenticated shell. A 401 mid-use flips
 * the session to 'expired', so this guard swaps the page for the expired gate automatically.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const { status } = useSession();
  if (status === 'active') {
    return <>{children}</>;
  }
  return <SessionGate />;
}
